import React from "react";
import {
  IconBook,
  IconBuilding,
  IconCalendar,
  IconChartBar,
  IconChartInfographic,
  IconPlus,
  IconGauge,
  IconKey,
  IconMail,
  IconMapPin,
  IconMessageCircle,
  IconNotes,
  IconPhone,
  IconTicket,
  IconTrash,
  IconUser,
  IconUsers,
  IconWorld,
  IconHeart,
  IconShieldLock,
  IconBellFilled,
} from "@tabler/icons-react";

const entityIcon = {
  add: (size = 16) => <IconPlus size={size} />,
  admin: (size = 16) => <IconUser size={size} />,
  calendar: (size = 16) => <IconCalendar size={size} />,
  dashboard: (size = 16) => <IconGauge size={size} />,
  company: (size = 16) => <IconBuilding size={size} />,
  survey: (size = 16) => <IconChartBar size={size} />,
  question: (size = 16) => <IconKey size={size} />,
  request: (size = 16) => <IconTicket size={size} />,
  profile: (size = 16) => <IconUser size={size} />,
  evaluation: (size = 16) => <IconChartBar size={size} />,
  compare: (size = 16) => <IconChartBar size={size} />,
  email: (size = 16) => <IconMail size={size} />,
  entry: (size = 16) => <IconTicket size={size} />,
  organization: (size = 16) => <IconBuilding size={size} />,
  location: (size = 16) => <IconMapPin size={size} />,
  message: (size = 16) => <IconMessageCircle size={size} />,
  phone: (size = 16) => <IconPhone size={size} />,
  report: (size = 16) => <IconChartBar size={size} />,
  trash: (size = 16) => <IconTrash size={size} />,
  user: (size = 16) => <IconUsers size={size} />,
  library: (size = 16) => <IconBook size={size} />,
  ticket: (size = 16) => <IconNotes size={size} />,
  api: (size = 16) => <IconChartInfographic size={size} />,
  general: (size = 16) => <IconWorld size={size} />,
  engagement: (size = 16) => <IconHeart size={size} />,
  role: (size = 16) => <IconShieldLock size={size} />,
  alert: (size = 16) => <IconBellFilled size={size} />,
};

export default entityIcon;
